import { APP_LOCALES, DEFAULT_LOCALE, type AppLocale } from '@devizy/shared';
import * as React from 'react';
import { IntlProvider as UseIntlProvider, type Messages } from 'use-intl';

import enMessages from '@/i18n/messages/en.json';
import frMessages from '@/i18n/messages/fr.json';

const MESSAGES: Record<AppLocale, Messages> = {
  fr: frMessages as Messages,
  en: enMessages as Messages,
};

const LOCALE_COOKIE = 'devizy.locale';

function isAppLocale(value: string): value is AppLocale {
  return (APP_LOCALES as readonly string[]).includes(value);
}

export function resolveLocale(): AppLocale {
  if (typeof document !== 'undefined') {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${LOCALE_COOKIE}=([^;]+)`));
    const fromCookie = match?.[1];
    if (fromCookie && isAppLocale(fromCookie)) {
      return fromCookie;
    }
  }
  if (typeof navigator !== 'undefined') {
    const code = navigator.language.slice(0, 2).toLowerCase();
    if (isAppLocale(code)) {
      return code;
    }
  }
  return DEFAULT_LOCALE;
}

export function I18nProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const locale = resolveLocale();
  return (
    <UseIntlProvider locale={locale} messages={MESSAGES[locale]} timeZone="Europe/Paris">
      {children}
    </UseIntlProvider>
  );
}
